module.exports = __webpack_public_path__ + "static/media/8OLA18.e2990076.jpg";